/**
 * Manda un mensaje a Sol y, si contestó, refresca lo que está en pantalla.
 *
 * Sol escribe con sus tools (el prospecto, tareas, campañas, tickets) por fuera
 * del caché de TanStack Query, así que lo que cambiaba no se veía hasta
 * refrescar la página (P-08). `invalidateQueries()` sin filtro marca todo como
 * viejo y vuelve a pedir solo lo que está montado: el resto se pide al volver
 * a abrirlo.
 */
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { sendChatMessage, type SendMessageRequest } from '@/services/ragChatService';

export function useEnviarASol() {
  const queryClient = useQueryClient();
  return useCallback(
    async (payload: SendMessageRequest) => {
      const res = await sendChatMessage(payload);
      if (res.ok) void queryClient.invalidateQueries();
      return res;
    },
    [queryClient],
  );
}
